var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24C12.5986 23.9995 12.2066 23.8782 11.8751 23.6519C6.96345 20.3175 4.83669 18.0312 3.66362 16.6019C1.16376 13.555 -0.0330542 10.4269 0.000693974 7.03938C0.0400669 3.1575 3.15428 0 6.94282 0C9.69768 0 11.6057 1.55188 12.7169 2.84438C12.7521 2.88491 12.7956 2.91741 12.8444 2.93968C12.8933 2.96195 12.9463 2.97348 13 2.97348C13.0537 2.97348 13.1067 2.96195 13.1556 2.93968C13.2044 2.91741 13.2479 2.88491 13.2831 2.84438C14.3943 1.55063 16.3023 0 19.0572 0C22.8457 0 25.9599 3.1575 25.9993 7.04C26.0331 10.4281 24.835 13.5563 22.3364 16.6025C21.1633 18.0319 19.0366 20.3181 14.1249 23.6525C13.7933 23.8786 13.4014 23.9997 13 24Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ebea74871be152e8ba92580af9c430aa.svg";
export { ForwardRef as ReactComponent };